/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientIdentifiers = sqliteTable('patient_identifiers', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  id_type: text('id_type'),
  id_value: text('id_value'),
});
